// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyApRfdAGQ6lwDRO-KrL6Yn7r33Nr3_nVZU",
  authDomain: "drusilla-b950d.firebaseapp.com",
  projectId: "drusilla-b950d",
  storageBucket: "drusilla-b950d.firebasestorage.app",
  messagingSenderId: "1009553563511",
  appId: "1:1009553563511:web:f1f5d6fb1955dd4a618b72",
  measurementId: "G-C18B621SBW"
};
// Check if Firebase is configured
const isConfigured = firebaseConfig.apiKey !== "AIzaSyAu3m2rGzoyQUL1AWaDS13ywcCqoI9AJt0";

let app = null;
let db = null;
let storage = null;
let auth = null;

if (isConfigured) {
  try {
    // Initialize Firebase
    app = initializeApp(firebaseConfig);
    
    // Initialize Firestore
    db = getFirestore(app);
    
    // Initialize Storage
    storage = getStorage(app);
    
    // Initialize Auth
    auth = getAuth(app);
  } catch (error) {
    console.error("Error initializing Firebase:", error);
  }
}

export { db, storage, auth, isConfigured };
export default app;